var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Input from 'antd/lib/input';
import { Icon } from '@ant-design/compatible';
import Popover from 'antd/lib/popover';
import classnames from 'classnames';
import { SketchPicker } from 'react-color';
import { alphaBg, isColor, getParentNode } from '../../utils';
var Color = /** @class */ (function (_super) {
    __extends(Color, _super);
    function Color(props) {
        var _this = _super.call(this, props) || this;
        _this.onMouseDown = function (e) {
            // 渐变条没有样式，取上级样式，有个预览小块，用 style 判断；
            var isWhite = getParentNode(e.target, ['saturation-white', 'flexbox-fix', ''], true);
            if (isWhite) {
                _this.isColorDown = true;
            }
        };
        _this.onMouseUp = function (e) {
            if (_this.isColorDown) {
                var domStyle = e.target.style;
                // react-color 里的预览小块，无法判断，用 style 判断;
                var noPreviewDom = !(domStyle.background &&
                    domStyle.right === '0px' &&
                    domStyle.top === '0px' &&
                    domStyle.left === '0px' &&
                    domStyle.bottom === '0px' &&
                    domStyle.borderRadius === '2px' &&
                    domStyle.position === 'absolute' &&
                    domStyle.boxShadow);
                _this.isColorDown = false;
                if (noPreviewDom) {
                    _this.props.onChange(_this.state.color);
                }
            }
        };
        _this.getColorPicker = function () {
            var color = _this.state.color;
            // react-color 没有 mouseup 事件，加在外层；
            return (React.createElement("div", { key: "picker", onMouseDown: _this.onMouseDown },
                React.createElement(SketchPicker, { color: color && isColor(color) ? color : 'rgba(0,0,0,0)', presetColors: [
                        '#f04134',
                        '#00a854',
                        '#108ee9',
                        '#f5317f',
                        '#f56a00',
                        '#7265e6',
                        '#ffbf00',
                        '#00a2ae',
                        '#222222',
                        '#404040',
                        // '#5a5a5a',
                        '#919191',
                        '#bfbfbf',
                        '#d9d9d9',
                        '#e9e9e9',
                        // '#f5f5f5',
                        // '#f7f7f7',
                        '#fbfbfb',
                        'transparent',
                    ], onChange: _this.colorHandleChange })));
        };
        _this.colorHandleChange = function (value) {
            var rgb = value.rgb;
            var color = rgb.a === 1 ? value.hex : "rgba(" + rgb.r + ", " + rgb.g + ", " + rgb.b + ", " + rgb.a + ")";
            _this.setState({
                color: color,
            }, function () {
                if (!_this.isColorDown) {
                    _this.props.onChange(color);
                }
                else {
                    _this.props.onChange(color, true);
                }
            });
        };
        _this.closeColorPicker = function () {
            _this.setState({
                showPicker: false,
            });
        };
        _this.handleVisibleChange = function (showPicker) {
            _this.setState({ showPicker: showPicker });
        };
        _this.inputBlur = function (e) {
            var target = e.target;
            if (_this.props.color !== target.value) {
                _this.props.onChange(target.value);
            }
        };
        _this.inputChange = function (e) {
            var target = e.target;
            _this.setState({
                color: target.value,
            });
        };
        _this.removeColor = function () {
            if (_this.props.color !== 'initial') {
                _this.props.onChange('initial');
            }
        };
        _this.state = {
            showPicker: false,
            color: props.color,
        };
        return _this;
    }
    Color.getDerivedStateFromProps = function (props, _a) {
        var prevProps = _a.prevProps;
        var nextState = {
            prevProps: props,
        };
        if (prevProps && prevProps.color !== props.color) {
            nextState.color = props.color;
        }
        return nextState;
    };
    Color.prototype.componentDidMount = function () {
        window.addEventListener('mouseup', this.onMouseUp);
    };
    Color.prototype.render = function () {
        var _a;
        var _b = this.props, title = _b.title, onChange = _b.onChange, type = _b.type, span = _b.span, props = __rest(_b, ["title", "onChange", "type", "span"]);
        var color = this.state.color;
        var className = classnames({
            'editor-color': true,
            active: this.state.showPicker,
        });
        var children = (React.createElement(Popover, { title: false, content: this.getColorPicker(), trigger: "click", visible: this.state.showPicker, onVisibleChange: this.handleVisibleChange, overlayClassName: "editor-list-popover" },
            React.createElement("a", { className: className, style: { background: "#fff url(" + alphaBg + ")" } },
                React.createElement("i", { style: { background: color }, className: "" + (!color || color === 'initial' ? 'no-color' : '') }, (!color || color === 'initial') && (React.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 60 20", id: "no-color", preserveAspectRatio: "none" },
                    React.createElement("g", { id: "Page-1" },
                        React.createElement("path", { d: "M0.5,19.5 L59.5,0.5", id: "Line", stroke: "#FF0000" }))))))));
        var classNameWrapper = classnames((_a = {
                'editor-color-wrapper': true
            },
            _a[props.className] = true,
            _a));
        if (this.props.type === 'cut') {
            return (React.createElement("div", __assign({}, props, { className: classNameWrapper }),
                children,
                React.createElement("span", { className: "color-close", onClick: this.removeColor },
                    React.createElement(Icon, { type: "close" }))));
        }
        return (React.createElement(Row, __assign({}, props, { className: classNameWrapper }),
            React.createElement(Col, { span: span[0] }, this.props.title),
            React.createElement(Col, { span: span[1], style: { position: 'relative' } }, children),
            React.createElement(Col, { span: span[2] },
                React.createElement(Input, { value: color, onBlur: this.inputBlur, onPressEnter: this.inputBlur, onChange: this.inputChange, size: "small", placeholder: "Add color" }))));
    };
    Color.propTypes = {
        className: PropTypes.string,
        title: PropTypes.any,
        color: PropTypes.string,
        onChange: PropTypes.func,
        type: PropTypes.string,
        span: PropTypes.array,
        gutter: PropTypes.number,
    };
    Color.defaultProps = {
        title: '颜色',
        onChange: function () { },
        span: [3, 9, 12],
        gutter: 8,
    };
    return Color;
}(React.Component));
export default Color;
